import React, { PureComponent } from 'react';
import { PropTypes as RPT } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../components/Button.react';
import Breadcrumbs from '../components/Breadcrumbs.react';
import Modal from '../components/Modal.react';
import { fetchQuestionnaireDate as fetchQuestionnaireDateAction } from '../../common/healthCheck/actions';
import { persistor } from '../../index';

const BASIC_TERMS_MODAL_ID = 'basic-terms';

const mapStateToProps = state => ({
  questionnaireData: state.healthCheck.questionnaireData,
  rehydrated: state.healthCheck.rehydrated,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    fetchQuestionnaireDate: fetchQuestionnaireDateAction,
  },
  dispatch,
);
class Mainpage extends PureComponent {
  static propTypes = {
    questionnaireData: RPT.any,
    rehydrated: RPT.bool,
    match: RPT.object,
    fetchQuestionnaireDate: RPT.func,
  }

  componentDidMount() {
    persistor.purge();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rehydrated && this.props.rehydrated !== nextProps.rehydrated) {
      const { fetchQuestionnaireDate, match } = this.props;
      const { params: { field_id } } = match;
      fetchQuestionnaireDate(field_id);
    }
  }

  render() {
    const { questionnaireData, match } = this.props;

    const removeTrailingSlash = url => url.replace(/\/$/, '');
    const firstQALink = !!questionnaireData.size
      && `${removeTrailingSlash(match.url)}/${questionnaireData.getIn([0, 'question_id'])}`;

    return (
      <div>
        <section className="block-questionary block-questionary--start">
          <div className="container">
            <Breadcrumbs />
            <div className="box-l-border">
              <h1 className="icon-heading">
                <i className="icon-square bg-red-order">
                  <img src={require('./images/gdpr-icon.svg')} alt="GDPR self assesment" />
                </i>
                GDPR Audit
              </h1>
            </div>

            <div className="desc row">
              <div className="col-image">
                <img src={require('./images/gdpr-data-protection-officer.png')} alt="GDPR Data Protection" />
              </div>
              <div className="col-content">
                {/* TODO extract header and description from json */}
                <p>GDPR Self Assesment Tool je přehledný a srozumitelný auditní
                  nástroj vyvinutý ve spolupráci s GDPR Lead Auditory.</p>

                <p>Struktura otázek, doplňujících vysvětlení i připravených odpovědí
                  splňuje <a href="/sluzby" className="link"><strong>roadmapu implementace</strong></a>.
                  Představuje tak i srozumitelný a&nbsp;objektivní checklist projektu.</p>

                <p>V 19 klíčových otázkách a odpovědích nejlépe zjistíte, co vás čeká
                  a&nbsp;jak jste připraveni na zajištění souladu s obecným nařízením na
                  ochranu osobních údajů. Je určen široké veřejnosti,
                  nejenom <a href="/gdpr/poverenec-pro-ochranu-osobnich-udaju" className="link"><strong>Pověřencům
                    pro ochranu osobních údajů</strong></a>.</p>

                <p>A co je nejdůležitější, tento sebehodnotící Maturity Model je zcela zdarma!</p>

                <Button
                  id=""
                  kind="primary"
                  className="btn-red"
                  link={firstQALink}
                  disabled={!firstQALink}
                >
                  Zahájit audit
                </Button>

                <span className="open-modal-link">
                  <a data-target={`#${BASIC_TERMS_MODAL_ID}`} data-toggle="modal">Základní pojmy</a>
                </span>
                <span className="open-modal-link"><a href="/blog/gdpr-audit-tool">Jak to celé funguje</a></span>

                <Modal modalId={BASIC_TERMS_MODAL_ID} title="Základní pojmy">
                  <p>Pro správné použití tohoto nástroje je nutno alespoň stručně definovat
                    základní pojmy týkající se zpracování osobních údajů tak, jak jsou uvedeny v GDPR.</p>

                  <p>
                    <strong>Osobním údajem</strong> se rozumí každá informace o určené nebo přímo či nepřímo určitelné
                    fyzické osobě, <strong>subjektu údajů</strong>. Subjekt údajů se považuje za určitelný, pokud
                    existuje technicky i fakticky realizovatelný způsob, jak určitou informaci spojit s konkrétním
                    člověkem. Osobními údaji jsou tedy nejen identifikátory (jméno, příjmení, datum
                    narození, rodné číslo, adresa), ale i kontaktní údaje (e-mail, telefon) či popisné
                    údaje (záznamy z kamer, informace o vzdělání, majetku, kvalifikaci, poskytnutých produktech).
                  </p>

                  <p>
                    <strong>Zpracováním údajů</strong> je každá operace nebo soustava operací, která je s osobními
                    údaji prováděna systematicky, za určitý účelem. Těmito operacemi může být shromáždění údajů,
                    jejich  uložení, využití, kombinování s dalšími informacemi nebo zveřejnění či zpřístupnění údajů.
                  </p>

                  <p>
                    <strong>Správcem údajů</strong> je každá organizace, která o zpracování osobních údajů rozhodla,
                    určila jeho účel a prostředky, nebo které je určité zpracování uloženo zvláštním zákonem
                    (zákoníkem práce, zákonem o bankách, o pojišťovnictví, obecní zřízením atd.)
                  </p>

                  <p>
                    <strong>Zpracovatelem</strong> je organizace, odlišná od správce, která na základě smlouvy nebo
                    zákonného zmocnění zpracovává osobní údaje pro správce, v jeho zájmu. Typickým zpracovatelem je
                    poskytovatel cloudových služeb, externí personální či mzdová účetní, provozovatel externího
                    archivu, bezpečnostní služba střežící objekt ve vlastnictví správce atd.
                  </p>
                </Modal>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Mainpage);
